export default __webpack_public_path__ + "static/media/youtube_logo.2edb10b6.svg";